import React from 'react';

/**
 * Arrow
 *
 * Simple svg icon showing a dotted arrow.
 * As this is only for a temporal landing page it is not moved to DS.
 *
 * Fixed cross-browser compatibility issues:
 * - Firefox: Use explicit width instead of "auto"
 * - All browsers: Proper responsive scaling with preserveAspectRatio
 */
const Arrow = ({ width = '240', height = '12', color = 'currentColor' }) => {
  // Convert "auto" to explicit width for Firefox compatibility
  const svgWidth = width === 'auto' ? '240' : width;

  return (
    <svg
      width={svgWidth}
      height={height}
      viewBox="0 0 240 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      style={{ maxWidth: '100%', height: 'auto' }}
    >
      <path
        d="M240 6 230 .226v11.547L240 6ZM0 7H2.963V5H0v2Zm8.975 0H14.985V5H8.975v2ZM20.99 7H26.99V5H20.99v2Zm11.997 0H38.98V5H32.988v2Zm11.99 0H50.975V5H44.977v2Zm12 0H62.984V5H56.977v2Zm12.019 0H74.99V5H68.996v2Zm11.987 0H86.984V5H80.983v2Zm12.008 0H98.997V5H92.991v2Zm11.998 0H110.989V5H104.989v2Zm12.005 0H122.997V5H116.994v2Zm11.999 0H134.994V5H128.993v2Zm12.006 0H146.997V5H140.999v2Zm11.998 0H158.999V5H152.997v2ZM165 7H171.001V5H165v2Zm12.002 0H183.001V5H177.002v2Zm12.001 0H195.006V5H189.003v2Zm12.002 0H207.002V5H201.005v2Zm12.003 0H219.01V5H213.008v2Zm11.997 0H231.006V5H225.005v2Z"
        fill={color}
      />
    </svg>
  );
};

export default Arrow;
